export const ITEM_WIDTH = 180;

const MAX_NB_ITEMS_PER_ROW = 3;

export function getNbItemsPerRow(totalNbItems: number): number {
    let nbItemsPerRow = MAX_NB_ITEMS_PER_ROW;
    if (totalNbItems <= 6) nbItemsPerRow -= 1;
    if (totalNbItems <= 3) nbItemsPerRow -= 1;
    return nbItemsPerRow;
}

/**
 * Returns a reordered version of the elements input parameter.
 * What should be the order?
 * The target is to move the (i+1)^th item in the elementw below the i^th element
 * (meaning on the same column), rather than on its right on the same row.
 */
export function orderElementsPerColumn<T extends string>(elements: T[]): T[] {
    const numColumns = getNbItemsPerRow(elements.length);
    const numRows = Math.ceil(elements.length / numColumns);
    const rearrangedElements = [];

    for (let i = 0; i < numRows; i += 1) {
        for (let j = 0; j < numColumns; j += 1) {
            const index = j * numRows + i;
            if (index < elements.length) {
                rearrangedElements.push(elements[index]);
            }
        }
    }
    return rearrangedElements;
}
